import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { AdType } from "@/types/constants";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatAdType(adType: AdType): string {
    return adType
        .split("-")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}

export function formatCurrency(amount: number | string | null | undefined, currency: string): string {
    if (amount === null || amount === undefined) return "-";
    
    // Handle USDT as a special case since it's not a standard ISO currency code
    if (currency === 'USDT') {
        return new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(amount)) + ' USDT';
    }
    
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
    }).format(Number(amount));
};

export function getAdTypeExplanation(adType: AdType): string {
    switch (adType) {
    case AdType.WHITE_HAT:
        return "Fully compliant and legal ads, such as fashion (clothing) or general e-commerce products. These follow all Meta policies without any issues.";
    case AdType.GREY_HAT:
        return "Ads that push the limits of Meta’s policies, often used for beauty and health products. These might include bold claims like “Get rid of back pain in just one week!” They aren’t strictly illegal but can get flagged or restricted.";
    case AdType.BLACK_HAT:
        return "Strictly prohibited ads that violate Meta’s policies, such as weapons, pornography, gambling, or counterfeit brand products. These can lead to immediate bans.";
    default:
        return "";
    }
}
